import React, { useLayoutEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { postSso } from '../../store/login/actions';

const SSOSucces = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useLayoutEffect(() => {
    const ssoParam = searchParams.get('ticket');

    if (ssoParam) {
      dispatch(
        postSso(
          { ticket: ssoParam },
          response => {
            localStorage.setItem('authorizationToken', response.accessToken);
            localStorage.setItem('refreshToken', response.refreshToken);
            localStorage.setItem('expiresIn', response.expiresIn);
            localStorage.setItem('expiresTime', response.expiresIn * 1000 + Date.now());

            const currentRedirect = localStorage.getItem('currentRedirect');
            navigate(currentRedirect || '/');
          },
          () => {
            navigate('/user-login/failure');
          }
        )
      );
    } else {
      navigate('/user-login');
    }
  }, []);

  return <></>;
};

export default SSOSucces;
